
export interface IntegrationData {
  icon: string;
  type: string;
  name: string;
  link: string;
}


export interface ShowIntegrationData {
  img: string;
  primaryText: string;
  secondaryText: string[];
}

export interface MojitoIntegrationParams {
  "serviceOrderId": number,
}

export type IntegrationDataType = 'empty' | 'drawerCreate' | 'drawerDetail' | 'componentInfo' | 'componentCreate' | 'pendingDrawer' | 'failedDrawer' | 'pendingComponent' | 'failedComponent'
